import { Divider } from '@doist/marketist';
import { useTranslation } from 'next-i18next';
import { ProductUIAppWindow } from '../product-ui-app-window/product-ui-app-window';
import { ProductUISceneContainer, ProductUISceneLayer } from '../product-ui-scene-container/product-ui-scene-container';
import { TemplateSidebarStandard } from '../product-ui-sidebar/product-ui-sidebar-templates';
import { ProductUISkeletonText } from '../product-ui-skeleton-text/product-ui-skeleton-text';
import { ProductUITask } from '../product-ui-task/product-ui-task';
import { ProductUITaskCircle } from '../product-ui-task-circle/product-ui-task-circle';
import { ProductUIView } from '../product-ui-view/product-ui-view';
function SectionsSubtasksScene() {
  const {
    t
  } = useTranslation('productui');
  return <ProductUISceneContainer backgroundVariant="wave-one" data-sentry-element="ProductUISceneContainer" data-sentry-component="SectionsSubtasksScene" data-sentry-source-file="sections-subtasks.tsx">
            <ProductUISceneLayer position="bottomLeft" data-sentry-element="ProductUISceneLayer" data-sentry-source-file="sections-subtasks.tsx">
                <ProductUIAppWindow inlineSize={800} showSidebar={true} sidebar={<TemplateSidebarStandard />} view={<ProductUIAppWindow.UIViews>
                            <ProductUIView variant="list">
                                <ProductUIView.Header title={t('sequence.getItAllDone.groceries')} breadcrumbs={[]} />
                                <ProductUIView.Section>
                                    <ProductUIView.SectionTitle>
                                        {t('sequence.sectionsSubtasks.thisWeekDinner')}
                                    </ProductUIView.SectionTitle>
                                    <Divider />
                                    <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" />} attributeSection={<ProductUITask.AttributeContainer>
                                                <ProductUITask.Attribute variant="subtask" count={2} completedCount={0} />
                                            </ProductUITask.AttributeContainer>}>
                                        {t('sequence.sectionsSubtasks.risotto')}
                                    </ProductUITask>
                                    <Divider />
                                    <ProductUITask subtask={true} taskCircleSection={<ProductUITaskCircle priority="p4" />}>
                                        {t('sequence.sectionsSubtasks.rice')}
                                    </ProductUITask>
                                    <Divider />
                                    <ProductUITask subtask={true} taskCircleSection={<ProductUITaskCircle priority="p4" />}>
                                        {t('sequence.sectionsSubtasks.mushrooms')}
                                    </ProductUITask>
                                    <Divider />
                                </ProductUIView.Section>
                                <ProductUIView.Section>
                                    <ProductUIView.SectionTitle>
                                        {t('sequence.sectionsSubtasks.nextWeekDinner')}
                                    </ProductUIView.SectionTitle>
                                    <Divider />
                                    <ProductUITask taskCircleSection={<ProductUITaskCircle priority="p4" />} attributeSection={<ProductUITask.AttributeContainer>
                                                <ProductUITask.Attribute variant="subtask" count={5} completedCount={0} />
                                            </ProductUITask.AttributeContainer>}>
                                        <ProductUISkeletonText width="60" />
                                    </ProductUITask>
                                    <Divider />
                                </ProductUIView.Section>
                            </ProductUIView>
                        </ProductUIAppWindow.UIViews>} data-sentry-element="ProductUIAppWindow" data-sentry-source-file="sections-subtasks.tsx" />
            </ProductUISceneLayer>
        </ProductUISceneContainer>;
}
export { SectionsSubtasksScene };